import {useSelectedVariantContext} from '../components/step2/context/SelectedVariantContext'
import {hasFeatureTag} from '../helpers/settings'

/**
 * Returns true if the current product is a custom shape and the feature flag is enabled.
 * Extracted for easy mocking in tests.
 * @returns {boolean}
 */
export function useIsCustomShape() {
    const {
        state: {productCreatedType},
    } = useSelectedVariantContext()

    return productCreatedType === 'custom_shape' && hasFeatureTag('custom_shape_step2')
}

